'use strict';

var Util = require("../layouts/util.js");
var React = require("react");
var Gatsby = require("../gatsby.js");
var Navigation = require("./navigation.js");
var ReasonReact = require("reason-react/src/ReasonReact.js");
var FooterModuleScss = require("./footer.module.scss");

var component = ReasonReact.statelessComponent("Footer");

var socialUrls = /* array */[
  "https://twitter.com/reasonconf",
  "https://www.facebook.com/ReasonConf-1334078980027448/",
  "https://www.github.com/reasonvienna"
];

function organizerWithPic(param) {
  var name = param[/* name */0];
  return React.createElement("a", {
              key: name,
              className: FooterModuleScss.creator,
              href: param[/* href */2]
            }, React.createElement("img", {
                  className: FooterModuleScss.userpic,
                  alt: "Photo of " + (String(name) + ""),
                  src: param[/* imgUrl */1]
                }), Util.s(name));
}

function make() {
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function () {
              return React.createElement("footer", {
                          className: FooterModuleScss.root
                        }, React.createElement("div", {
                              className: "container_centered grid"
                            }, ReasonReact.element(/* None */0, /* None */0, Navigation.make("/", /* Some */[/* Footer */1], /* array */[])), React.createElement("nav", {
                                  className: FooterModuleScss.additional
                                }, React.createElement("ul", undefined, React.createElement("li", undefined, ReasonReact.element(/* None */0, /* None */0, Gatsby.Link[/* make */0]("/coc/", /* None */0, /* None */0, /* None */0, /* array */[Util.s("Code of Conduct")]))), React.createElement("li", undefined, ReasonReact.element(/* None */0, /* None */0, Gatsby.Link[/* make */0]("/privacy/", /* None */0, /* None */0, /* None */0, /* array */[Util.s("Privacy Policy")]))), React.createElement("li", undefined, React.createElement("a", {
                                              href: "/contact/"
                                            }, Util.s("Contact Us"))), React.createElement("li", undefined, ReasonReact.element(/* None */0, /* None */0, Gatsby.Link[/* make */0]("/imprint/", /* None */0, /* None */0, /* None */0, /* array */[Util.s("Imprint")]))))), React.createElement("nav", {
                                  className: FooterModuleScss.social
                                }, ReasonReact.element(/* None */0, /* None */0, Gatsby.SocialIcons[/* make */0](socialUrls, /* Some */[FooterModuleScss.socialIcon], /* Some */["#8eaeb6"], /* array */[]))), React.createElement("section", {
                                  className: FooterModuleScss.copyright
                                }, Util.md("\nReasonConf is a [not-for-profit conference](/about/) event by ReasonVienna and ReactVienna communities.\n\nDesign by [Andrey Okonetchnikov](http://okonet.ru)\n\n© [ReasonConf](mailto:hi@reason-conf.com), 2018"))));
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* subscriptions */component[/* subscriptions */13],
          /* jsElementWrapped */component[/* jsElementWrapped */14]
        ];
}

var Link = 0;

var SocialIcons = 0;

var SocialIcon = 0;

exports.Link = Link;
exports.SocialIcons = SocialIcons;
exports.SocialIcon = SocialIcon;
exports.component = component;
exports.socialUrls = socialUrls;
exports.organizerWithPic = organizerWithPic;
exports.make = make;
/* component Not a pure module */



// WEBPACK FOOTER //
// ./src/components/footer.js